const module = { name: 'photos/gallery/shared', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as screenfull } from 'swug-fdRequire-call:screenfull';



import { default as swipe } from 'swug-fdRequire-call:shared/global/jcarousel.swipe';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { mps as mps_AdTypes_onLoad_onMPSReady } from 'require-global';

const { AdTypes, onLoad: onMPSReady } = mps_AdTypes_onLoad_onMPSReady;


let $gallery


let $toolbar


let thumbnailsActive = false


const Selectors = {
    ACTIVE_THUMBNAIL: '.js-active-thumbnail',
    THUMBNAILS: '.js-carousel-thumbnail-button',
    LEFT_ARROW: '.js-fd-carousel-arrow-left',
    RIGHT_ARROW: '.js-fd-carousel-arrow-right',
}


const DataAttribs = {
    ACTIVE_CLASS: 'activeClass',
    BTN_ACTION: 'action',
    INACTIVE_CLASS: 'inactiveClass',
}


const Attribs = {
    TAB_INDEX: 'tabindex',
}


const stopAutoplay = () => {
    const autoplayButton = document.getElementById('splide_autoplay_button');
    const playButton = document.getElementsByClassName('splide__toggle__play')[0];
    if (window.getComputedStyle(playButton).display === 'none') {
        autoplayButton.click();
    }
}
function toggleFullscreen() {
    screenfull.toggle($gallery[0]);
}
function showThumbnails() {
    if (thumbnailsActive) {
        return;
    }
    const $thumbnailToggle = $toolbar.find('.thumbnails-toggle');
    $thumbnailToggle
        .addClass($thumbnailToggle.data(DataAttribs.ACTIVE_CLASS))
        .removeClass($thumbnailToggle.data(DataAttribs.INACTIVE_CLASS));
    $gallery.addClass('thumbnails-active');
    $(Selectors.THUMBNAILS).each((index, img) => $(img).removeAttr(Attribs.TAB_INDEX));
    $(Selectors.ACTIVE_THUMBNAIL).trigger('focus');
    const $leftArrow = $(Selectors.LEFT_ARROW);
    const $rightArrow = $(Selectors.RIGHT_ARROW);
    $leftArrow.addClass('hide');
    $rightArrow.addClass('hide');
    thumbnailsActive = true;
}
function hideThumbnails() {
    if (!thumbnailsActive) {
        return;
    }
    const $thumbnailToggle = $toolbar.find('.thumbnails-toggle');
    $thumbnailToggle
        .addClass($thumbnailToggle.data(DataAttribs.INACTIVE_CLASS))
        .removeClass($thumbnailToggle.data(DataAttribs.ACTIVE_CLASS));
    $(Selectors.THUMBNAILS).each((index, img) => $(img).attr(Attribs.TAB_INDEX, '-1'));
    $gallery.removeClass('thumbnails-active');
    const $leftArrow = $(Selectors.LEFT_ARROW);
    const $rightArrow = $(Selectors.RIGHT_ARROW);
    $leftArrow.removeClass('hide');
    $rightArrow.removeClass('hide');
    thumbnailsActive = false;
}
function toggleThumbnails() {
    return thumbnailsActive ? hideThumbnails() : showThumbnails();
}
function onThumbnailClick() {
    hideThumbnails();
}
function onToolbarClick() {
    const $target = $(this);
    const action = $target.data(DataAttribs.BTN_ACTION);
    if (!action) {
        return;
    }
    switch (action) {
        case 'toggle-fullscreen':
            toggleFullscreen();
            break;
        case 'toggle-thumbnails':
            toggleThumbnails();
            break;
    }
}
function onFullscreenChange() {
    if (!$(screenfull?.element).is($gallery)) {
        return;
    }
    const $fullscreenToggle = $toolbar.find('.fullscreen-toggle');
    $fullscreenToggle
        .toggleClass($fullscreenToggle.data(DataAttribs.ACTIVE_CLASS), screenfull.isFullscreen)
        .toggleClass($fullscreenToggle.data(DataAttribs.INACTIVE_CLASS), !screenfull.isFullscreen);
}
function init() {
    swipe.init();
    $gallery = $('#photoGallery');
    $(Selectors.THUMBNAILS).on('click', onThumbnailClick);
    $toolbar = $gallery.find('.toolbar');
    $toolbar.on('click', 'li', onToolbarClick);
    if (screenfull.enabled) {
        $(document).on(screenfull.raw.fullscreenchange, onFullscreenChange);
    }
}
function run() {
    const numSlidesBetweenAds = 3;
    const adSlideClass = 'js-adSlide';
    const splideList = document.querySelector('#gallery-carousel .splide__list');
    const splideNonAdElements = Array.from(splideList.querySelectorAll('.splide__slide:not(.js-adSlide)'));
    const interstitial = document.getElementById('gallery-interstitial');
    splideNonAdElements.forEach((slide, index) => {
        const isTimeForAd = (index + 1) % numSlidesBetweenAds === 0;
        if (isTimeForAd) {
            const adSlide = document.createElement('li');
            adSlide.className = `splide__slide gallery_slide ${adSlideClass}`;
            adSlide.dataset.adSlide = 'true';
            splideList.insertBefore(adSlide, slide.nextSibling);
        }
    });
    fdCarousel.init('gallery-carousel', { perPage: 1, autoplay: 'pause' });
    const galleryCarousel = fdCarousel.getInstance('gallery-carousel');
    const currentSlideIndicator = document.getElementById('current-indicator-slide-number');
    const thumbnails = document.getElementsByClassName('js-carousel-thumbnail');
    const thumbnailButtons = [...document.getElementsByClassName('js-carousel-thumbnail-button')];
    const showInterstitial = () => {
        const adContainer = interstitial.querySelector('.ad');
        interstitial.style.display = 'block';
        onMPSReady(({ isAvailable, insertAd }) => {
            if (!isAvailable) {
                return;
            }
            const alreadyLoaded = interstitial.dataset.loaded === 'true';
            if (!alreadyLoaded) {
                insertAd(`#${adContainer.id}`, AdTypes.INTERSTITIAL);
                interstitial.dataset.loaded = 'true';
            }
        });
    };
    const hideInterstitial = () => {
        interstitial.style.display = 'none';
    };
    const swipeThreshold = 30;
    ['left', 'right'].forEach((side) => {
        const zone = document.createElement('div');
        zone.style.cssText = `position:absolute;top:0;${side}:0;width:25%;height:100%;z-index:1;`;
        let touchStartX = 0;
        let touchStartY = 0;
        zone.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
        }, { passive: true });
        zone.addEventListener('touchend', (e) => {
            const deltaX = e.changedTouches[0].clientX - touchStartX;
            const deltaY = e.changedTouches[0].clientY - touchStartY;
            if (Math.abs(deltaX) > swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
                stopAutoplay();
                galleryCarousel.go(deltaX < 0 ? '+1' : '-1');
            }
        });
        interstitial.appendChild(zone);
    });
    const setActiveThumbnail = (thumbnail) => {
        for (let i = 0; i < thumbnailButtons.length; i++) {
            thumbnailButtons[i].classList.remove('js-active-thumbnail');
            thumbnails[i].classList.remove('active');
        }
        const currentThumbnailButton = thumbnailButtons.find(thumbnailButton => thumbnailButton.getAttribute('data-index') === thumbnail.getAttribute('data-index'));
        thumbnail.classList.add('active');
        currentThumbnailButton.classList.add('js-active-thumbnail');
    };
    const updateSlideIndicator = () => {
        const slideList = [...document.getElementsByClassName('gallery_slide')];
        const currentSlide = slideList[galleryCarousel.index];
        const adSlideIndicator = document.getElementsByClassName('js-current-indicator-ad')[0];
        const totalPhotosIndicator = document.getElementById('total-indicator-slide-number');
        if (!currentSlide) {
            return;
        }
        else if (currentSlide.classList.contains(adSlideClass)) {
            adSlideIndicator.style.display = 'inline';
            currentSlideIndicator.style.display = 'none';
            totalPhotosIndicator.style.display = 'none';
            return;
        }
        adSlideIndicator.style.display = 'none';
        currentSlideIndicator.style.display = 'inline';
        totalPhotosIndicator.style.display = 'inline';
        const visibleSlides = slideList.slice(0, galleryCarousel.index + 1);
        const nonAdSlideCount = visibleSlides.filter(slide => !slide.classList.contains(adSlideClass)).length;
        currentSlideIndicator.textContent = nonAdSlideCount;
        const thumbIndex = nonAdSlideCount - 1;
        setActiveThumbnail(thumbnails[thumbIndex]);
    };
    for (let i = 0; i < thumbnails.length; i++) {
        thumbnailButtons[i].addEventListener('click', () => {
            const targetIndex = parseInt(thumbnails[i].getAttribute('data-index')) - 1;
            const slideList = [...document.getElementsByClassName('gallery_slide')];
            let nonAdSlideCount = -1;
            const nonAdIndex = slideList.findIndex((slide) => {
                if (!slide.classList.contains(adSlideClass)) {
                    nonAdSlideCount++;
                }
                return nonAdSlideCount === targetIndex;
            });
            galleryCarousel.go(nonAdIndex);
            updateSlideIndicator();
        });
    }
    document.getElementById('photoGallery_replayBtn').addEventListener('click', () => {
        galleryCarousel.go(0);
        currentSlideIndicator.textContent = 1;
        stopAutoplay();
    });
    document.getElementById('fd-carousel-arrow-left').addEventListener('click', () => {
        stopAutoplay();
    });
    document.getElementById('fd-carousel-arrow-right').addEventListener('click', () => {
        stopAutoplay();
    });
    document.getElementById('gallery-carousel').addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            stopAutoplay();
        }
    });
    galleryCarousel.on('move', () => {
        const splideElements = Array.from(splideList.querySelectorAll('.splide__slide'));
        if (galleryCarousel.index === splideElements.length - 1) {
            stopAutoplay();
        }
        const currentSlide = splideElements[galleryCarousel.index];
        if (currentSlide && currentSlide.classList.contains(adSlideClass)) {
            window.mps.refreshAds();
            showInterstitial();
        }
        else {
            hideInterstitial();
        }
        updateSlideIndicator();
    });
}
module.exports = {
    init,
    run
};
export default module.exports;